import { render, staticRenderFns } from "./upper-bank-edit.vue?vue&type=template&id=5861981c&scoped=true&"
import script from "./upper-bank-edit.vue?vue&type=script&lang=js&"
export * from "./upper-bank-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861981c",
  null
  
)

export default component.exports